module.exports = __webpack_public_path__ + "img/icon_question_mark_active.11c62253.svg";